module.exports = __webpack_public_path__ + "static/media/logo_reservando_word_white.48a07e41.png";